<template>
  <section>
    <SmartTitle weight="medium" class="main-title">Budget</SmartTitle>
    <div class="dashboard-container flex flex-wrap flex-col">
      <SmartRow class="main-section mt-3">
        <SmartButtonDash
          v-for="service in items"
          :key="service.title"
          v-bind="service"
          @click.native="changeRoute(service.name)"
          class="lg:col-4 md:col-12 sm:col-12 flex flex-wrap"
        />
        <SmartCard/>
      </SmartRow>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'BudgetList',
  data() {
    return {
      name: 'ExportarBases',
      services: [
        {
          id: '11',
          title: 'Budget Anual',
          icon: 'budget',
          description: 'Importe e gerencie Budgets',
          buttonText: 'Mais detalhes',
          sizeIcon: 'big',
          iconColor: '#82C85A',
          name: 'Budget Anual',
          permission: 'web.metas.visualizar_budget'
        },
        {
          id: '13',
          title: 'Importar Meta Macro',
          description: '',
          icon: 'upload_file',
          sizeIcon: 'big',
          buttonText: 'Mais detalhes',
          iconColor: '#bb008f',
          name: 'Import Macro Goal',
          permission: 'web.metas.distribuicao_meta_macro'
        },
        {
          id: '19',
          title: 'Importar Meta Regional',
          icon: 'upload_file',
          description: '',
          buttonText: 'Mais detalhes',
          sizeIcon: 'big',
          iconColor: '#fbaa26',
          name: 'Import View Goal',
          permission: 'web.metas.distribuicao_meta_regional'
        }
      ]
    };
  },
  methods: {
    changeRoute(routerName) {
      this.$router.push({ name: routerName });
    }
  },
  computed: {
    ...mapGetters({
      webPermission: 'auth/webPermission'
    }),
    items() {
      return this.services.filter(item => this.webPermission.find(p => p.name === item.permission));
    }
  }
};
</script>
